import { render, staticRenderFns } from "./temperatureSensor.vue?vue&type=template&id=3920c123&scoped=true&"
import script from "./temperatureSensor.vue?vue&type=script&lang=js&"
export * from "./temperatureSensor.vue?vue&type=script&lang=js&"
import style0 from "./temperatureSensor.vue?vue&type=style&index=0&id=3920c123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920c123",
  null
  
)

export default component.exports